import React from "react";
import { Helmet } from "react-helmet-async";

function SEO({ title, description, metaDesciption, bodyclass }) {
  const defaultTitle = "Bercastle";
  const pageDescription = metaDesciption || description || "Media Technology and Voice solutions";
  const pageKeywords = "Digital, IT, Media, Technology, Voice, Marketing, AI";
  const pageTitle = title || "Home";

  return (
    <Helmet
      htmlAttributes={{ lang: "en" }}
      defaultTitle={defaultTitle}
      titleTemplate={`%s | ${defaultTitle}`}
      bodyAttributes={{
        class: bodyclass
      }}
    >
      <title>{pageTitle}</title>
      <meta name="description" content={pageDescription} />
      <meta name="keywords" content={pageKeywords} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDescription} />
      <meta property="og:site_name" content={defaultTitle} />
      <meta name="og:type" content="website" />

      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />

      <meta name="twitter:site" content="bercastle.com" />
      <meta name="twitter:title" content={`${pageTitle} | ${defaultTitle}`} />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}

export default SEO;
